import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const OlympiadSubjectModal = ({ onClose, fetchData, propData }) => {
    const [form, setForm] = useState({ name: "" });
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [isStudyMaterial, setIsStudyMaterial] = useState("");
    const [state, setState] = useState("");

    useEffect(() => {
        if (propData) {
            setName(propData.subject_name || "");
            setIsStudyMaterial(propData.isStudyMaterial || "");
        }
    }, [propData]);

    const submitHandler = async () => {
        if (!name.trim()) {
            window.NotificationUtils.showError("Please fill in Subject Name fields");
            return;
        }
        setLoading(true);
        try {
            if (propData) {
                await window.Platform.database.updateOlympiadSubject({
                    subject_name: name,
                    id: propData.id,
                    isStudyMaterial: isStudyMaterial,
                });
                window.NotificationUtils.showSuccess("Subject updated successfully");
            } else {
                await window.Platform.database.addOlympiadSubject({ subject_name: name, isStudyMaterial: isStudyMaterial, });
                window.NotificationUtils.showSuccess("Subject saved successfully");
            }
            setName("");
            setIsStudyMaterial("");
            fetchData();
            onClose();
        } catch (err) {
            window.NotificationUtils.showError(err?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
            <StyledDialogContent>
                <ModalHeaderContainer>
                    <Typography variant="h5">
            {propData ? "Update Subject Name" : "Add Subject Name"}
          </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>

                {loading && <OpaqueLoading />}

                <Stack gap={2} padding={2}>
                    <FormControl fullWidth>

                        <TextField
                            label="Subject Name"
                            value={name || ''}
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                        />
                    </FormControl>
                    {/* <FormControl fullWidth className="mt-3">
                        <InputLabel id="study-material-label">Is Study Material</InputLabel>
                        <Select
                            labelId="study-material-label"
                            label="Is Study Material"
                            value={isStudyMaterial}
                            onChange={(e) => setIsStudyMaterial(e.target.value)}
                        >
                            <MenuItem value={"yes"}>Yes</MenuItem>
                            <MenuItem value={"no"}>No</MenuItem>
                        </Select>
                    </FormControl> */}

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={submitHandler}
                            disabled={!name}
                        >
                            {propData ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Stack>
            </StyledDialogContent>

        </Dialog>
    );
};

export default OlympiadSubjectModal;
